document.addEventListener("click", (event) => {
  const openButton = event.target.closest("[data-menu-open]");
  const closeButton = event.target.closest("[data-menu-close]");
  const menu = document.querySelector("[data-mobile-menu]");

  if (openButton && menu) {
    menu.hidden = false;
  }

  if (closeButton && menu) {
    menu.hidden = true;
  }
});

document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
  const mainImage = gallery.querySelector("[data-product-main]");
  const wrapper = gallery.closest(".product-detail");
  const thumbs = wrapper ? Array.from(wrapper.querySelectorAll("[data-product-thumb]")) : [];
  let activeIndex = 0;

  function showImage(index) {
    if (!mainImage || !thumbs.length) return;

    activeIndex = (index + thumbs.length) % thumbs.length;
    const thumb = thumbs[activeIndex];
    const nextImage = thumb.dataset.productImage;
    if (!nextImage) return;

    mainImage.removeAttribute("srcset");
    mainImage.src = nextImage;
    thumbs.forEach((button) => button.classList.remove("active"));
    thumb.classList.add("active");
  }

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => showImage(index));
  });

  gallery.querySelectorAll("[data-gallery-next]").forEach((button) => {
    button.addEventListener("click", () => showImage(activeIndex + 1));
  });

  gallery.querySelectorAll("[data-gallery-prev]").forEach((button) => {
    button.addEventListener("click", () => showImage(activeIndex - 1));
  });
});

const swatchColors = {
  black: "#000000",
  white: "#ffffff",
  pearl: "#f7f2e8",
  ivory: "#fff7df",
  beige: "#e8ddbd",
  cream: "#f3ead2",
  nude: "#d8b89d",
  champagne: "#e8d3a2",
  "rose gold": "#c9907a",
  gold: "#d8b65f",
  silver: "#c9c9c9",
  "baby blue": "#b8d6f2",
  "sky blue": "#9fd0f5",
  "light blue": "#a9cfee",
  blue: "#23318f",
  navy: "#20256f",
  red: "#dc2626",
  burgundy: "#7f1d2d",
  grey: "#8a8a8a",
  gray: "#8a8a8a",
  green: "#166534",
  mint: "#b7e4d0",
  sage: "#b8c7a5",
  brown: "#7c4a2d",
  yellow: "#facc15",
  purple: "#7e57c2",
  lavender: "#c9b6e4",
  pink: "#f9a8d4",
  blush: "#f4b6c2",
  coral: "#fb8f7d",
  orange: "#f59e0b",
  clear: "#f8fafc",
  "بيج": "#e8ddbd",
  "ابيض": "#ffffff",
  "أبيض": "#ffffff",
  "اسود": "#000000",
  "أسود": "#000000",
  "ازرق": "#23318f",
  "أزرق": "#23318f",
  "لبني": "#b8d6f2",
  "روز جولد": "#c9907a",
  "ذهبي": "#d8b65f",
  "فضي": "#c9c9c9",
  "وردي": "#f9a8d4"
};

function colorFromLabel(label) {
  const normalized = label.trim().toLowerCase();
  const cleaned = normalized.replace(/[_-]/g, " ").replace(/\s+/g, " ");
  if (swatchColors[cleaned]) return swatchColors[cleaned];

  const parts = cleaned.split(/[\\/,+|]/).map((part) => part.trim()).filter(Boolean);
  for (const part of parts) {
    if (swatchColors[part]) return swatchColors[part];
  }

  const keys = Object.keys(swatchColors).sort((a, b) => b.length - a.length);
  const matchedKey = keys.find((key) => cleaned.includes(key));
  return matchedKey ? swatchColors[matchedKey] : "#d8d8d8";
}

function updateCartCount(count) {
  document.querySelectorAll("[data-cart-count]").forEach((badge) => {
    badge.textContent = count;
    badge.hidden = count === 0;
  });
}

function showCartToast(text) {
  let toast = document.querySelector("[data-cart-toast]");
  if (!toast) {
    toast = document.createElement("div");
    toast.className = "cart-toast";
    toast.dataset.cartToast = "";
    document.body.appendChild(toast);
  }

  toast.textContent = text;
  toast.classList.add("is-visible");
  window.clearTimeout(showCartToast.timeout);
  showCartToast.timeout = window.setTimeout(() => toast.classList.remove("is-visible"), 2400);
}

async function addFormToCart(form) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { Accept: "application/json" },
    body: new FormData(form)
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.description || "Could not add this product.");
  }

  const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((res) => res.json());
  updateCartCount(cart.item_count);
}

document.querySelectorAll(".option-value--color").forEach((label) => {
  const text = label.dataset.swatchName || label.textContent.trim();
  label.style.setProperty("--swatch-color", colorFromLabel(text));
});

document.querySelectorAll(".card-form").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const button = form.querySelector("button");
    if (button) button.disabled = true;

    try {
      await addFormToCart(form);
      showCartToast("Added to cart. Keep shopping.");
    } catch (error) {
      showCartToast(error.message);
    } finally {
      if (button) button.disabled = false;
    }
  });
});

document.querySelectorAll(".product-form").forEach((form) => {
  const variantInput = form.querySelector("[data-variant-id]");
  const variantsScript = form.querySelector("[data-product-variants]");
  const message = form.querySelector("[data-product-message]");
  const addButton = form.querySelector("[data-add-button]");
  const buyNowButton = form.querySelector("[data-buy-now]");
  const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

  function selectedOptions() {
    return Array.from(form.querySelectorAll(".product-option"))
      .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
      .map((group) => {
        const checked = group.querySelector("[data-option-value]:checked");
        return checked ? checked.value : "";
      });
  }

  function setMessage(text, isError = false) {
    if (!message) return;
    message.textContent = text;
    message.classList.toggle("error", isError);
  }

  function updateVariant() {
    if (!variants.length || !variantInput) return;

    const selected = selectedOptions();
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    const available = Boolean(variant && variant.available);

    form.querySelectorAll(".product-option").forEach((group) => {
      const checked = group.querySelector("[data-option-value]:checked");
      const label = group.querySelector("[data-selected-label]");
      if (checked && label) label.textContent = checked.value;
    });

    if (variant) variantInput.value = variant.id;
    if (addButton) {
      addButton.disabled = !available;
      addButton.childNodes[0].textContent = available ? "Add To Cart " : "Sold Out ";
    }
    if (buyNowButton) buyNowButton.disabled = !available;
    setMessage("");
  }

  form.addEventListener("change", (event) => {
    if (event.target.matches("[data-option-value]")) updateVariant();
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (addButton) addButton.disabled = true;
    setMessage("Adding...");

    try {
      await addFormToCart(form);
      setMessage("Added to cart. You can keep shopping.");
      showCartToast("Added to cart. Keep shopping.");
    } catch (error) {
      setMessage(error.message, true);
    } finally {
      updateVariant();
    }
  });

  if (buyNowButton) {
    buyNowButton.addEventListener("click", async () => {
      buyNowButton.disabled = true;
      setMessage("Redirecting to checkout...");

      try {
        await addFormToCart(form);
        window.location.href = "/checkout";
      } catch (error) {
        buyNowButton.disabled = false;
        setMessage(error.message, true);
      }
    });
  }

  updateVariant();
});
